// Libs
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

// Components & Utils
import LoginApi from "../api/Login";
import { useGlobalValue } from "../utils/GlobalState";
import { setIsLoading, setErrors, setIsLoggedIn, setSysCfg, setService, setUser } from "../utils/Actions";

export default function Login() {
  // Setup default state
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [, dispatch] = useGlobalValue();
  let history = useHistory();

  // Login Action
  const submitLogin = e => {
    e.preventDefault();
    setIsLoading(true, dispatch);

    LoginApi.login(username, password)
      .then(response => {
        setIsLoading(false, dispatch);
        setIsLoggedIn(true, dispatch);
        setSysCfg(response.sys_config, dispatch);
        setService(response.service, dispatch);
        setUser(response.user, dispatch);
        history.push("/mealplans");
      })
      .catch(apiErrors => {
        setErrors(apiErrors, dispatch);
        setIsLoading(false, dispatch);
      });
  };

  return (
    <div>
      <br />
      <div className="row justify-content-center">
        <form className="col-sm-6 col-sm-push-3 well">
          <label>Username:</label>
          <input
            type="text"
            className="form-control"
            placeholder="Username..."
            autoComplete="username"
            required
            onChange={event => setUsername(event.target.value)}
            value={username}
          />
          <br />
          <label>Password:</label>
          <input
            type="password"
            className="form-control"
            placeholder="Password..."
            autoComplete="password"
            required
            onChange={event => setPassword(event.target.value)}
            value={password}
          />
          <br />
          <button className="btn btn-lg btn-success btn-block" onClick={submitLogin}>
            Login
          </button>
        </form>
      </div>
    </div>
  );
}
